/**
 * Array filter helper to remove "null" and undefined values.
 * E.g.:
 * const array: (string | null)[] = ['foo', 'bar', null, 'zoo', null];
 * const filteredArray: string[] = array.filter(notEmpty);
 */
export function valueNotNullable<TValue>(value: TValue | null | undefined): value is NonNullable<TValue> {
  return value !== null && value !== undefined;
}
